import React from 'react';
import translations from '../../../../translations';

import { fetchAllFlows } from '../../../../actions/reduxActions/flows';
import { connect } from 'react-redux';
import Select from 'react-select';
import { selectStyles } from '../../../../utils/core';

/**
 * @param {Function} onChange
 * @param {String} selectedItem
 * @param {String} flowId
 */
export class FlowSelectBox extends React.Component {

    componentDidMount() {
        const {
            tenantId,
            authenticationToken,
            fetchAllFlows: fetchFlows,
        } = this.props;

        fetchFlows(
            tenantId,
            authenticationToken,
        );
    }

    render() {
        const {
            items,
            onChange,
            selectedItem,	
            flowId,
        } = this.props;

        const selectedFlow = selectedItem && items.length > 0
            ? items.find(flow => flow.developerName === selectedItem)
            : null;

        const currentSelection = selectedFlow !== null
            ? { label: selectedFlow.developerName, value: selectedFlow.id.id }
            : null;

        return (
            <div className="form-group">
                <div>
                    <label className="control-label">{translations['subflow select label']}</label>

                    <Select
                        styles={{ ...selectStyles, container: provided => ({ ...provided, width: '300px' }) }}
                        placeholder={translations['subflow select placeholder']}
                        onChange={onChange}
                        value={currentSelection}
                        options={
                            items
                            // Don't show current (parent) flow in select list
                                .filter(item => item.id.id !== flowId)
                                .map(flow => ({ label: flow.developerName, value: flow.id.id }))
                        }
                        noOptionsMessage={() => 'No results found'}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ currentUser, flows }) => ({
    items: flows.all,
    authenticationToken: currentUser.authenticationToken,
    tenantId: currentUser.tenantId,
});

const mapDispatchToProps = {
    fetchAllFlows,
};

export default connect(mapStateToProps, mapDispatchToProps)(FlowSelectBox);
